import {NciAdministrationService} from '@services/NciAdministration/NciAdministrationService';
import React, {useCallback, useEffect} from 'react';
import {useTablePage} from 'utils/hooks/useTablePage';
import {NciDict} from './types';
import {Stack} from '@mui/material';
import {useNciDictsTableData} from './useNciDictsTableData';
import NewTable from '@ui/NewTable/NewTable';
import {PageSchema} from 'utils';
import {BaseData} from 'utils/hooks/useNewPageData';

type NciTableProps = {
    selectedDict: NciDict;
};

const service = NciAdministrationService;

export const NciTable = <T extends BaseData>({selectedDict}: NciTableProps) => {
    const schemaGetter = useCallback(() => {
        if (!selectedDict.pathCode) return Promise.resolve({} as PageSchema);
        return service.getDictsTableSchema(selectedDict.pathCode);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedDict.pathCode]);

    const [pageStore, updatePageData] = useNciDictsTableData(selectedDict);

    const {
        schema,
        columns,
        tableConfig,
        requiredConfig,
        page,
        rows,
        rowsPerPage,
        filterConfig,
        setRowsPerPage,
        setPage,
        ref,
        handleUpdate,
    } = useTablePage({
        pageId: selectedDict.pathCode,
        pageStore,
        service,
        updatePageData,
        schemaGetter,
        initialRowsPerPage: 10,
    });

    const addEntityHandle = async (values: T) => {
        await service.createNciDictUnit(selectedDict.findAllUrl, values);
        handleUpdate();
    };

    useEffect(() => {
        if (!!schema) {
            handleUpdate();
        }
    }, [selectedDict, schema, handleUpdate, rowsPerPage, page, filterConfig]);

    return (
        <Stack sx={{flexGrow: 1}}>
            <div className='page'>
                <div
                    ref={ref}
                    className='table-container'
                >
                    <NewTable
                        tableName={selectedDict.pathCode}
                        columns={columns}
                        tableConfig={tableConfig}
                        rows={rows}
                        rowsPerPage={rowsPerPage}
                        setPage={setPage}
                        page={page}
                        setRowsPerPage={setRowsPerPage}
                        addEntityHandle={addEntityHandle}
                        onUpdate={handleUpdate}
                        totalElements={pageStore?.total || 0}
                        requiredConfig={requiredConfig}
                        filterConfig={filterConfig}
                    />
                </div>
            </div>
        </Stack>
    );
};
